import type { ClientRectObject } from "@floating-ui/react";
import { Box } from "@stenajs-webui/core";
import { type CSSProperties, type FC, memo } from "react";

import styles from "./Spotlight.module.css";

export interface SpotlightStyle {
  borderRadius?: number;
  padding?: number;
}

interface SpotlightProps {
  rect: ClientRectObject | undefined;
  style?: SpotlightStyle;
}

export const Spotlight: FC<SpotlightProps> = memo(({ rect, style }) => {
  if (!rect) {
    return null;
  }

  return (
    <Box
      background={"gray"}
      position={"fixed"}
      style={getSpotlightStyle(rect, style)}
      className={styles.spotlight}
    />
  );
});

function getSpotlightStyle(
  rect: ClientRectObject,
  style?: SpotlightStyle,
): CSSProperties {
  const padding = style?.padding ?? 4;
  const borderRadius = style?.borderRadius ?? 4;

  const width = Math.round(rect.width + padding * 2);
  const height = Math.round(rect.height + padding * 2);
  const left = Math.round(rect.left - padding);
  const top = Math.round(rect.top - padding);

  return {
    top: `${top}px`,
    left: `${left}px`,
    width: `${width}px`,
    height: `${height}px`,
    borderRadius: `${borderRadius}px`,
  };
}
